// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageField__container-cfa741 {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
}

.ImageField__image-b8b906 {
  margin-inline-end: 16px;
  width: 120px;
  height: 120px;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.ImageField__no-image-wrapper-fe82b7 {
  position: absolute;
  top: 0;
  left: 0;
}

.ImageField__content-c652fe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.ImageField__description-da3e88 {
  margin-top: 8px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.ImageField__upload-bd5e5c {
  position: relative;
}

.ImageField__upload-text-b85c9c {
  display: block;
}

.ImageField__file-input-f11d21 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  font-size: 0;
  text-indent: -60px;
}

.ImageField__remove-avatar-fe7006 {
  margin-inline-start: 8px;
}

.ImageField__remove-avatar-fe7006:hover {
  background-color: var(--brand-primary-0);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/ImageField/ImageField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,wCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n}\n\n.image {\n  margin-inline-end: 16px;\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.no-image-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.description {\n  margin-top: 8px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.upload {\n  position: relative;\n}\n\n.upload-text {\n  display: block;\n}\n\n.file-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 1;\n  cursor: pointer;\n  font-size: 0;\n  text-indent: -60px;\n}\n\n.remove-avatar {\n  margin-inline-start: 8px;\n}\n\n.remove-avatar:hover {\n  background-color: var(--brand-primary-0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImageField__container-cfa741`,
	"image": `ImageField__image-b8b906`,
	"no-image-wrapper": `ImageField__no-image-wrapper-fe82b7`,
	"noImageWrapper": `ImageField__no-image-wrapper-fe82b7`,
	"content": `ImageField__content-c652fe`,
	"description": `ImageField__description-da3e88`,
	"upload": `ImageField__upload-bd5e5c`,
	"upload-text": `ImageField__upload-text-b85c9c`,
	"uploadText": `ImageField__upload-text-b85c9c`,
	"file-input": `ImageField__file-input-f11d21`,
	"fileInput": `ImageField__file-input-f11d21`,
	"remove-avatar": `ImageField__remove-avatar-fe7006`,
	"removeAvatar": `ImageField__remove-avatar-fe7006`
};
module.exports = ___CSS_LOADER_EXPORT___;
